import React, { useState } from 'react';
import Base from './pages/Base/Base';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import { PersistGate } from 'redux-persist/integration/react';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { store, persistor } from './redux/store/';

import Loading from './components/loading/Loading';
import SplashScreen from './components/splashScreen/SplashScreen';
import ScrollToTop from "./ScrollToTop";
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
function App() {
    const [splashDone, setSplashDone] = useState(false);
    const theme = createTheme({
        palette: {
            primary: {
                main: '#001665',
            },
            secondary: {
                main: '#7896ff',
            },
            error: {
                main: '#f50057'
            },
            tertiary: {
                main: '#e3d507'
            }

        },
    });
  return (
    <div className='shipment-background'>
      {!splashDone && <SplashScreen onFinish={() => setSplashDone(true)} />}
      <HelmetProvider>
        <Provider store={store}>
          <PersistGate loading={<Loading />} persistor={persistor}>
            <BrowserRouter>
              <ScrollToTop>
                <ThemeProvider theme={theme}>
                    <Base />
                </ThemeProvider>
              </ScrollToTop>
            </BrowserRouter>
          </PersistGate>
        </Provider>
      </HelmetProvider>
    </div>
  );
}

export default App;
